import { useMemo } from "react"

import { useFlags } from "../feature"

interface UseSSOForInternalUsersProps {
  email: string
}

interface UseSSOForInternalUsersValue {
  isSSORequiredForInternalUsers: boolean
}

export const useSSOForInternalUsers = ({
  email,
}: UseSSOForInternalUsersProps): UseSSOForInternalUsersValue => {
  const flags = useFlags()

  const isInternalUser: boolean = email.includes("@nzero.com")

  const isSSORequiredForInternalUsers: boolean =
    Boolean(flags.sso_require_internal_users) && isInternalUser

  return useMemo(
    () => ({
      isSSORequiredForInternalUsers,
    }),
    [isSSORequiredForInternalUsers]
  )
}
